var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.imageUrl)+" "),_c('OssUpload',{ref:"ossUpload",attrs:{"imageType":"agent"},on:{"change":_vm.changeImageUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }